<template>
  <v-app>

    <!-- Barra principal -->
    <v-app-bar 
      app 
      color="white" 
      v-if="getLogeadoLMS && getUsuarioLMS.roll == 'EDITOR'" 
      class ="ma-2 mt-2" 
      style="border-radius: 10px;"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <!-- Menu lateral izquierdo -->
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="getLogeadoLMS && getUsuarioLMS.roll == 'EDITOR'"
      class="elevation-3 mt-3 pb-5"
      style="border-radius: 10px;"
    >
      <v-list nav dense>
        <v-subheader>Menú</v-subheader>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in menu"
            :key="i"
            :to="{ name: item.path }"
            color="primary"
            class="cyan lighten-5"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" color="primary"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <!-- Router -->
    <v-main>
      <router-view/>
    </v-main>

    <!-- Footer  -->
    <v-footer app class="pa-0" v-if="getLogeadoLMS">
      <Navegador/>
    </v-footer>

    <NoInternet v-if="!estatusInternet"/>

    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4" id="eye">
        <path d="M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1"></path>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 7" id="mouth">
        <path d="M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5"></path>
      </symbol>
    </svg>
    
  </v-app>
</template>

<script>
  import {
    ActionPerformed,
    PushNotificationSchema,
    PushNotifications,
    Token,
  } from '@capacitor/push-notifications';
  // Componentes
  import { Device } from '@capacitor/device';

  // Componentes
  import Navegador  from '@/components/Navegador.vue'
  import NoInternet from '@/components/alertas/NoInternet.vue'

  // Librerías y más
  import { mapGetters, mapActions } from 'vuex'

  // Capacitor
  import { Network } from '@capacitor/network';

  export default {
    components:{
      Navegador,
      NoInternet,
    },

    name: 'App',

    data: () => ({
      drawer: false,
      drawer2:false,
      mini:false,
      escuela:1,
      color_active:'',
      estatusInternet: false,
      tokejs:'',
    }),

    async created ( ){

      if( this.getUsuarioLMS ){
        // Actualizar el tipo de dispositivo, esto es para poder recibir notificaciones
        const info = await Device.getInfo();

        const payload = { id: this.getUsuarioLMS.id, dispositivo: info.operatingSystem }
        this.$http.post('usuario.tipodispositivo', payload).then( response => {
          this.cargar = false
        }).catch( error => {
          this.cargar = false
          if( error.status == 400 || error.status == 500){
            this.parametros.mensaje      = error.body.message
            this.parametros.dialogError  = true 
            this.parametros.color        = '#FF2C2C' 
            this.respuestaAlerta         = true 
          }
        }).finally(()=>{ this.cargar = false })
      }

      Network.addListener('networkStatusChange', status => {
        this.estatusInternet = status.connected ;
      });

      const status = await Network.getStatus();
      this.estatusInternet = status.connected ;
    },


    methods:{
      ...mapActions( 'login', [ 'salirLogin' ]),

      salir(){
        this.salirLogin()
      },
      
    },

    computed:{
      ...mapGetters( 'login', [ 'getUsuarioLMS', 'getLogeadoLMS', 'getDatosUsuarioLMS' ]),

      menu( ){
        if( this.getUsuarioLMS.id == 19638 ){
          return [
            { text: 'Actividades Diarias Todos'   , icon: 'mdi-circle-medium' , path: 'ActividadesDiariasTodos'      },
          ]
        }else{
          return [
            { text: 'Ni por vendedora'   , icon: 'mdi-circle-medium' , path: 'NiVendedora'      },
            { text: 'Tickets'            , icon: 'mdi-circle-medium' , path: 'TicketsEditor'    },
            { text: 'Kpi general'        , icon: 'mdi-circle-medium' , path: 'KPIGeneral'       },
            { text: 'Kpi Montos'         , icon: 'mdi-circle-medium' , path: 'KPIMontos'        },
            { text: 'Rep. Semanal Ventas', icon: 'mdi-circle-medium' , path: 'RepSemanalVentas' },
            { text: 'Requisiciones'      , icon: 'mdi-circle-medium' , path: 'Requisiciones'    },
          ]
        }

      }
    }
  };
</script>

<style>

  .v-main__wrap{
    background: #f8f9fa !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }
</style>